import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const copyToClipboardFallback = async (text) => {
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    throw new Error("Clipboard API not available");
  } catch (err) {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      // Make it invisible but still selectable
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand('copy');
      textArea.remove();
      return successful;
    } catch (fallbackErr) {
      if (process.env.NODE_ENV !== 'production') {
          console.error('Fallback copy failed', fallbackErr);
      }
      return false;
    }
  }
};
